import React, {useMemo} from 'react';
import dayjs from "dayjs";
import {Sorter} from "../../shared/components/Sorter";
import LogTemplate from "./LogTemplate";

const AdminLog = () => {
    const searchParams = useMemo(() => ({
        begin: dayjs().subtract(1, "week").startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        end: dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
        logType: 'log_admin',
        isUnix: false,
    }), []);

    const columns = useMemo(() => ([
        {
            title: '아이디',
            dataIndex: 'id',
            search: true,
        },
        {
            title: '이름',
            dataIndex: 'name',
            search: true,
        },
        {
            title: 'API',
            dataIndex: 'api',
            search: true,
        },
        {
            title: 'Body',
            dataIndex: 'body',
            ellipsis: true,
        },
        {
            title: '날짜',
            dataIndex: 'created',
            render: (time) => dayjs(time).format('YYYY-MM-DD HH:mm:ss'),
            sorter: (a, b) => Sorter.DATE(a.time, b.time),
        },
    ]), []);

    return (
        <LogTemplate
            columns={columns}
            defaultSearchParams={searchParams}
            routerUrl={'/logs/admin'}
            logName={'AdminLog'}
        />
    );
};

export default AdminLog;